import { useId, type ReactNode } from 'react';
import { cx } from './cx';
import s from './Switch.module.css';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  className?: string;
  /** Libellé accessible si aucun `label` visible. */
  'aria-label'?: string;
}

export function Switch({ checked, onChange, label, description, disabled, className, ...rest }: SwitchProps) {
  const id = useId();
  return (
    <div className={cx(s.wrap, className)}>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={rest['aria-label']}
        aria-labelledby={label ? `${id}-l` : undefined}
        disabled={disabled}
        className={cx(s.track, checked && s.on)}
        onClick={() => onChange(!checked)}
      >
        <span className={s.thumb} />
      </button>
      {(label || description) && (
        <div className={s.text}>
          {label && (
            <label id={`${id}-l`} htmlFor={id} className={s.label}>
              {label}
            </label>
          )}
          {description && <p className={s.desc}>{description}</p>}
        </div>
      )}
    </div>
  );
}
